import Web3 from 'web3';
import { getTotalBalanceByTokenAddress } from 'utils/contract/web3';
import { MULTICHAIN_SETUP, SUPPORTED_CHAINS } from 'constants/variables';
import { Dictionary } from 'ts-essentials';
import erc20Abi from 'blockchain/abi/erc20.json';
import { getToken } from 'blockchain/tokensMetadata';
import { BigNumber } from 'bignumber.js';
import { amountFromWei } from 'utils/contract/common-function';
import { ethers } from 'ethers';
import dsProxyRegistryAbi from 'blockchain/abi/ds-proxy-registry.json';
import { createIlkData$ } from 'utils/contract/ilks';
import {
  fetchAllLoansByAddress,
  getLoansSummary,
} from 'app/pages/ManageLoan/ManageLoanHandle';
import { isUndefined } from 'lodash';
import { Vault, VaultSummary } from 'types';
const { PROXY_REGISTRY } = MULTICHAIN_SETUP.polka.address;

export interface IAppContext {
  token: Dictionary<string, string>;
  address: Dictionary<string>;
  nativeSymbol: string;
  joinsIlk: Dictionary<string, string>;
}

export class Api {
  api: Web3;
  balance: string | undefined;
  public address: string | undefined;
  public proxy: string | undefined;
  public appContext: IAppContext;

  constructor(rpc?: string) {
    //console.log('rpc', rpc);
    if (rpc) {
      const provider = new Web3.providers.HttpProvider(rpc);
      this.api = new Web3(provider);
    } else {
      this.api = new Web3(Web3.givenProvider);
    }
    this.appContext = MULTICHAIN_SETUP.polka;
  }

  get currentProvider() {
    return this.api.currentProvider;
  }

  isSupportedChain(chainId: string): boolean {
    return SUPPORTED_CHAINS.map(chain => chain.chainId).includes(chainId);
  }

  setAddress(string: string): void {
    this.address = string;
  }

  setProxy(proxy: string): void {
    this.proxy = proxy;
  }

  isProxyZero(): boolean {
    return this.proxy === ethers.constants.AddressZero;
  }

  initContract(abi: any, address: string) {
    return new this.api.eth.Contract(abi, address);
  }

  async fetchBalance() {
    const { api, address = '' } = this;
    const balance = await api.eth.getBalance(address);
    this.balance = api.utils.fromWei(balance, 'ether');
    return new BigNumber(api.utils.fromWei(balance, 'ether'));
  }

  async getTotalBalanceByTokenAddress(token: string, getTokenName?: string) {
    try {
      const { api, address } = this;
      const contract = this.initContract(
        erc20Abi,
        this.appContext.address[token],
      );

      //console.log(address);

      const balance = await contract.methods.balanceOf(address).call();
      const symbol = await contract.methods.symbol().call();

      const t = getTokenName ? getToken(getTokenName) : getToken(token);
      // if (t.precision === 18) {
      //   return { balance: Web3.utils.fromWei(balance, 'ether'), token: symbol };
      // }
      const cvBalance = new BigNumber(balance);
      return {
        balance: amountFromWei(cvBalance, t.precision),
        token: symbol,
      };
    } catch (err) {
      //console.log(err.message);
    }
  }

  async handleConfirmOpenLoan() {
    const { api, address } = this;
  }

  async createNewProxy(proxy: string) {
    this.proxy = proxy;
  }

  async initProxyAddress() {
    const { api, address } = this;
    try {
      const contract = new api.eth.Contract(
        dsProxyRegistryAbi as any,
        PROXY_REGISTRY,
      );
      const proxy = await contract.methods.proxies(address).call();
      //console.log('proxy', proxy);
      this.proxy = proxy;
    } catch (error) {}
  }

  async fetchListToken() {
    // console.log(
    //   'process.env.REACT_APP_POLKA_FOUNDRY_RPC',
    //   process.env.REACT_APP_POLKA_FOUNDRY_RPC,
    // );
    //console.log('this.api.givenProvider', this.api.givenProvider);

    return Promise.all(
      Object.keys(MULTICHAIN_SETUP.polka.token).map(ilk => createIlkData$(ilk)),
    );
  }

  async getListIlks() {
    const ilksData = await this.fetchListToken();
    return ilksData.filter(
      ilk => ilk.token !== 'DAI' && ilk.token !== 'SAI' && ilk.token !== 'ETH',
    );
  }

  async fetchOwnerDetail() {
    const { address, proxy } = this;
    if (!address) {
      return { listLoanData: [], loanSM: [] };
    }
    const res = await fetchAllLoansByAddress(address, proxy);
    const listLoanData = isUndefined(res[0]) ? [] : res;
    const loanSM: VaultSummary = getLoansSummary(res as Vault[]);
    return { listLoanData, loanSM };
  }
}
